import styled from "styled-components";

export const HeaderArea = styled.div`
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 68px;
  background-color: ${(props) => props.color};
  border-bottom: 1px solid #fff;
  z-index: 9998;
  &:hover #toggle-open {
    height: 340px;
  }
  .inner {
    height: 68px;
    width: 1500px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo {
    width: 150px;
    @media (max-width: 1024px) {
      width: 100px;
    }
  }
  .mobile-show {
    display: none !important;
  }
  .header-right {
    display: flex;
    align-items: center;
    gap: 32px;

    @media (max-width: 1024px) {
      font-size: 14px;
    }
  }
  .header-center {
    width: 1080px;
    display: flex;
    align-items: center;

    justify-content: space-between;
    .header-link {
      width: calc(100% / 6);
      text-align: center;
      font-weight: bold;
      color: var(--white);
    }

    @media (max-width: 1500px) {
      font-size: 14px;
    }

    @media (max-width: 1024px) {
      display: none;
    }
  }
  .header-right-menu {
    display: flex;
    align-items: center;
    justify-content: right;
    gap: 12px;
    height: 68px;
    width: 150px;
    cursor: pointer;
    color: #fff;
    font-weight: bold;

    img {
      width: 14px;
      height: 14px;
      object-fit: contain;
    }
  }
  @media (max-width: 1500px) {
    .inner {
      width: 90vw !important;
    }
  }

  @media (max-width: 1024px) {
    .header-right {
    }
    .header-right-menu {
      width: auto;
      gap: 8px;
    }

    .header-right {
      gap: 16px;
    }
  }
  @media (max-width: 1024px) {
    position: fixed;
    top: 0px;

    .mobile-show {
      display: flex !important;
    }
  }
  &.kor {
    .kor {
      display: block;
    }

    .eng {
      display: none;
    }
  }

  &.eng {
    .kor {
      display: none;
    }

    .eng {
      display: block;
    }
  }
`;

export const HomeHeaderArea = styled.div`
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 68px;
  border-bottom: 1px solid #fff;
  z-index: 9998;
  .inner {
    height: 68px;
    width: 1500px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo {
    width: 150px;
    @media (max-width: 1024px) {
      width: 100px;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 32px;
    @media (max-width: 1024px) {
      font-size: 14px;
    }
  }
  .mobile-show {
    display: none !important;
  }
  .header-right-menu {
    display: flex;
    align-items: center;
    gap: 12px;
    height: 68px;
    cursor: pointer;
    color: #fff;
    font-weight: bold;

    img {
      width: 14px;
      height: 14px;
      object-fit: contain;
    }
  }
  @media (max-width: 1500px) {
    .inner {
      width: 90vw !important;
    }
  }

  @media (max-width: 1024px) {
    position: fixed;
    top: 0px;
  }

  @media (max-width: 1500px) {
    .inner {
      width: 90vw !important;
    }
  }

  @media (max-width: 1024px) {
    .header-right {
    }
    .header-right-menu {
      width: auto;
      gap: 8px;
    }

    .header-right {
      gap: 16px;
    }
  }
  @media (max-width: 1024px) {
    position: fixed;
    top: 0px;

    .mobile-show {
      display: flex !important;
    }
  }
  &.kor {
    .kor {
      display: block;
    }

    .eng {
      display: none;
    }
  }

  &.eng {
    .kor {
      display: none;
    }

    .eng {
      display: block;
    }
  }
`;

export const HeaderToggleOpen = styled.div`
  overflow: hidden;
  height: 0%;
  transition: height 0.3s ease;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  width: 100%;

  top: 68px;
  max-height: 340px;
  width: calc(100%);
  transition: all 0.3s ease;
  .inner {
    height: 100%;
    width: 1080px;
  }
  .mobile-show {
    display: none !important;
  }
  .link-flex-line {
    display: flex;
    padding-top: 24px;
    box-sizing: border-box;
    padding-bottom: 24px;
    width: 100%;
    justify-content: space-between;
    align-items: start;
    text-align: center;
  }

  .link-vertical-line {
    width: calc(100% / 6);
  }

  .header-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 60px;
    font-size: 18px;
    transition: all 0.3s ease;
    font-weight: normal;
    border-bottom: 2px solid transparent;

    &:hover {
      border-bottom: 2px solid #ccc;
      font-weight: bold;
    }
  }

  @media (max-width: 1500px) {
    .inner {
      width: 100vw !important;
    }
  }

  @media (max-width: 1024px) {
    .mobile-show {
      display: flex !important;
    }
    width: 100%;
    height: 100vh !important;
    max-height: 100vh !important;
    position: fixed;
    right: -100%;
    background-color: rgba(0, 0, 0, 0.6);
    .wrap {
      display: flex;
      height: calc(100vh - 68px);
      align-items: unset;
      justify-content: right;
    }
    .inner {
      display: flex;
      height: calc(100vh - 68px);
      background-color: var(--white);
      width: 70% !important;
      margin: 0 !important;
      align-items: unset;
      justify-content: right;
    }
    .link-flex-line {
      display: flex;
      flex-wrap: wrap;
      justify-content: right;
      background-color: var(--white);
      width: calc(100%);
      height: min-content;
      padding-top: 0px;
      padding-bottom: 0px;
    }

    .link-vertical-line {
      width: 100%;
      height: 62px;
      overflow-y: hidden;
      overflow-x: hidden;
      max-height: 1000px;
      background-color: var(--white);
    }

    .header-link {
      text-align: left;
      width: calc(100% - 24px);
      padding-left: 24px;
      font-size: 14px;
      justify-content: left;
      border-bottom: 1px solid #ccc;
      width: 100%;
    }

    a.header-link {
      text-align: left;
      width: calc(100% - 32px);
      padding-left: 32px;
      font-size: 12px;
      justify-content: left;
      border-bottom: 1px solid #ccc;
      width: 100%;
      background-color: #efefef;
    }
  }
`;
